import ApiClient from './api-client';

const client = new ApiClient();

export default client;
